module.exports = __webpack_public_path__ + "static/media/attachments-icon-green.87cb1018.svg";